enum ProductType {
    Undefined = "",
    Deposit = "DEPOSIT",
    Lending = "LENDING",
}
export default ProductType